// | isDelinquent | softDisconnected | accountStatus          | Result                         |
// |--------------|------------------|------------------------|--------------------------------|
// | false        | -                | -                      | NORMAL                         |
// | true         | false            | Not NONPAYDISCONNECTED | PENDING_VOLUNTARY_DISCONNECT   |
// | true         | true             | Not NONPAYDISCONNECTED | COMPLETED_VOLUNTARY_DISCONNECT |
// | true         | false            | NONPAYDISCONNECTED     | PENDING_NON_PAY_DISCONNECT     |
// | true         | true             | NONPAYDISCONNECTED     | COMPLETED_NON_PAY_DISCONNECT   |
// Evaluates the CPC accountCollectionState directly from the BBDS bill/data response
export const getAccountCollectionStateFromBillData = (billData) => {
  const balance = billData && billData.balance;
  // billData.balance is normalized to {} when the API returns null, which must
  // still be treated as missing rather than a real (non-delinquent) balance
  if (!balance || Object.keys(balance).length === 0) return '';
  if (!balance.isDelinquent) return 'NORMAL';
  const status = billData.softDisconnected ? 'COMPLETED' : 'PENDING';
  const type = (billData.accountStatus || '').toUpperCase() === 'NONPAYDISCONNECTED' ? 'NON_PAY' : 'VOLUNTARY';
  return `${status}_${type}_DISCONNECT`;
};

// Returns the numeric balanceDue from the bill/data payload, or undefined when absent.
export const getBillDataBalanceDue = (billData) => {
  if (!billData || !billData.balance || billData.balance.balanceDue == null) {
    return undefined;
  }
  return Number(billData.balance.balanceDue) || 0;
};

export const getBillDataPastDueBalance = (billData) => {
  if (!billData || !billData.balance || billData.balance.pastDueBalance == null) {
    return undefined;
  }
  return Number(billData.balance.pastDueBalance) || 0;
};

export const getBillDataAutopayEnabled = (billData) => {
  if (!billData || !billData.autopay) return false;
  return billData.autopay.status === 'ON';
};

const shouldShowLateFeeCredit = (billData) => {
  if (!billData) return false;
  const status = (billData.lateFeeDetails && billData.lateFeeDetails.creditStatus || '').toUpperCase();
  const paymentStatus = (billData.autopay && billData.autopay.paymentStatus || '').toUpperCase();
  return status !== 'INELIGIBLE'
    && !!(billData.autopay) && !(
    billData.autopay.status === 'ON'
      && paymentStatus !== 'DENIED'
  );
};

export default shouldShowLateFeeCredit;
